import Star from '@img/icons/star.svg';
import React, { FunctionComponent } from 'react';
import { RatingStarsStyles } from './RatingStars.styles';

const { Stars, StarWrapper, NumberOfRatings } = RatingStarsStyles;

export interface RatingStarsProps {
  averageReviewRating: number;
  centered?: boolean;
  numberOfRatings?: number;
  reserveSpace?: boolean;
  removeMargins?: boolean;
}

const RatingStars: FunctionComponent<RatingStarsProps> = ({
  averageReviewRating,
  centered = false,
  numberOfRatings,
  reserveSpace,
  removeMargins = false,
}) => {
  const activeStars = getActiveStars(averageReviewRating);
  const inactiveStars = 5 - activeStars;

  return (
    <>
      {activeStars > 0 ? (
        <Stars isZero={false} centered={centered} removeMargins={removeMargins}>
          {Array(activeStars)
            .fill(0)
            .map((x, index) => (
              <StarWrapper key={index} active={true}>
                <Star />
              </StarWrapper>
            ))}
          {Array(inactiveStars)
            .fill(0)
            .map((x, index) => (
              <StarWrapper key={index} active={false}>
                <Star />
              </StarWrapper>
            ))}
          {numberOfRatings !== undefined && <NumberOfRatings>({numberOfRatings})</NumberOfRatings>}
        </Stars>
      ) : (
        <>
          {reserveSpace === true ? (
            <Stars isZero={true} centered={centered} removeMargins={removeMargins}>
              {Array(activeStars)
                .fill(0)
                .map((x, index) => (
                  <StarWrapper key={index} active={true}>
                    <Star />
                  </StarWrapper>
                ))}
              {Array(inactiveStars)
                .fill(0)
                .map((x, index) => (
                  <StarWrapper key={index} active={false}>
                    <Star />
                  </StarWrapper>
                ))}
              {numberOfRatings !== undefined && <NumberOfRatings>({numberOfRatings})</NumberOfRatings>}
            </Stars>
          ) : null}
        </>
      )}
    </>
  );
};

export function getActiveStars(averageReviewRating: number): number {
  return Math.ceil(averageReviewRating / 10);
}

export default RatingStars;
